@import (reference) '../../../constants/spacing.module.less';

.expandable-message-container {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-4;
  align-items: flex-start;
}

.message-container {
  // line clamp requires `display: -webkit-box`, so we can't use flexbox/gap
  > p:not(:last-child) {
    margin-bottom: @space-8;
  }
}

.expander-button {
  font-size: 12px;
  line-height: 16px;
}
